import { memo, SVGProps } from 'react';
import styles from './index.module.scss';
import { classNames } from '@/utils/ui/classname';

const Spinner = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={classNames(styles.loadingSpinner, className)}
    viewBox="0 0 220 220"
    fill="none"
    {...props}
  >
    <path
      stroke="#F28600"
      strokeWidth={2}
      d="M105.842 81.275c6.793-1.107 13.783.648 20.081 5.34l.606.462 61.9 48.444-25.982 22.589-.002.003-14.018 12.269C136.514 180.821 123.214 186 109.96 186c-13.254 0-26.555-5.179-38.467-15.618l-.005-.004L31 135.407v-22.808l47.357 36.75.012.009 8.64 6.499v.001c14.176 10.637 31.124 10.803 45.386.499l.677-.499 25.863-19.423.093-.067 1.057-.767-1.017-.821-62.252-50.222a27.921 27.921 0 0 1 7.559-3.02c.255-.041.506-.087.738-.132.255-.048.489-.093.719-.129l.01-.002Zm8.326 57.449-.009.002c-6.793 1.107-13.784-.647-20.08-5.338l-.608-.463-61.9-48.447L57.552 61.89l.002-.003 14.018-12.269C83.486 39.18 96.786 34 110.04 34c13.254 0 26.555 5.18 38.467 15.618l.005.004L189 84.592V107.4l-47.357-36.748-.006-.004-.006-.004-8.639-6.5-.001-.001c-14.4-10.806-31.662-10.806-46.062 0L61.065 83.567l-.092.068-1.058.767 1.017.82 62.252 50.222a27.926 27.926 0 0 1-7.573 3.024c-.25.04-.496.085-.724.129-.255.048-.489.092-.719.128Z"
    />
  </svg>
);

const MemoizedSpinner = memo(Spinner);

export { MemoizedSpinner as Spinner };
